<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <!-- table start -->
        <div class="card mb-4">
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <nav>
                <slot name="head-actions">.</slot>
                <!-- <Search :PlaceHolder="placeHolderText" @search="handleSearch" /> -->
                <Search
                  :placeholder="searchPlaceholder"
                  @onsearch="handleSearch"
                />
              </nav>
              <main>
                <slot>
                  <table class="table">
                    <thead style="margin: 0; padding: 0">
                      <tr style="margin: 0; padding: 0">
                        <slot name="table-heading">Default Header</slot>
                      </tr>
                    </thead>
                    <tbody v-if="users.length" style="margin: 0; padding: 0">
                      <slot name="table-contents-place">Default content</slot>
                    </tbody>
                  </table>
                </slot>
              </main>
              <!-- Pagination   @page-change="handlePageChange" :current-page="currentPage" :total-pages="totalPags" -->
              <!-- <pagination :all-data="allData" @content-change="handleContentChange" /> -->
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 10vh; /* Full viewport height */
                "
                v-if="apiLoading"
              >
                <!-- <span style="font-weight: bold; font-size: 1.5em; color: black"
                  >Loading...</span
                > -->
                <loader />
              </div>
              <!-- <div v-if="allData.length > 0"></div> -->
              <pagination
                v-if="!apiLoading"
                :all-data="allData"
                @content-change="handleContentChange"
                @loader-set="loaderSet"
              />

              <div v-if="users.length < 1">
                <p class="tocenter-container" v-if="!apiLoading">
                  No Records found.
                </p>
              </div>

              <!--  -->
            </div>
          </div>
        </div>
        <!-- table end -->
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex.js";
import Pagination from "../../components/pagination.vue";
import Search from "../../components/search.vue";
import loader from "../../special_clinics/dialysis/loader.vue";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      users: [],
      allData: {},
      apiLoading: true,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
    };
  },
  components: {
    Pagination,
    Search,
    loader,
  },
  props: {
    mainUrl: {
      type: [String],
      required: true,
    },
    tableSearchUrl: {
      type: [String],
      required: false,
    },
    searchPlaceholder: {
      type: [String],
      required: false,
    },
  },

  methods: {
    async handleSearch(searchTerm) {
      //console.log("the serch rem is " +searchTerm);
      try {
        this.apiLoading = true;
        const url = this.tableSearchUrl;
        const body = { search_param: searchTerm };

        const rs = await generalApiRequest(url, "GET", body, 1);

        this.allData = rs.data;
        this.apiLoading = false;
        // console.log(this.allData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    handleContentChange(contents) {
      this.users = contents;
      // console.log(this.users.length < 1);
      // console.log(this.users);

      this.$emit("child-data-state-mount", contents);
    },

    loaderSet(value) {
      if (value == true) {
        this.users = [];
      }
      this.tableLoading = value;
      //console.log(value);
      //this.apiLoading = value;
    },

    async callApi() {
      try {
        const url = this.mainUrl + "?page=1";
        const body = {};
        // console.log(
        //   "this cant be null=========================================="
        // );
        // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, "GET", body, 1);

        console.log(data.data);

        this.allData = data.data;
        this.apiLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    mount_child_data_state() {
      this.$emit("child-data-state-mount", this.users);
    },
  },

  // beforeMount() {
  //   this.callApi();
  // },

  mounted() {
    this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
